import type { PortfolioLobCompetenceResource } from "api/generated";
import type { LobCompetence } from "portfolio/types";

export const lobCompetenceFromDto = (
  resource: PortfolioLobCompetenceResource,
): LobCompetence => ({
  id: resource.id,
  schoolId: resource.school_id,
  lobCompetence: {
    id: resource.lob_competence.id,
    name: resource.lob_competence.name,
    tooltip: resource.lob_competence.tooltip ?? "",
  },
  usedInActivitiesAmount: resource.used_in_activities_amount,
  educationLevels: resource.education_levels,
});
